import React from 'react'
import PropTypes from 'prop-types'

const FranchisePage = ({ children }) => children

FranchisePage.propTypes = {
  children: PropTypes.node,
}

export default FranchisePage